import { render, staticRenderFns } from "./guide-section-tabs.vue?vue&type=template&id=94a6a33c"
import script from "./guide-section-tabs.js?vue&type=script&lang=js&external"
export * from "./guide-section-tabs.js?vue&type=script&lang=js&external"
import style0 from "./guide-section-tabs.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports